import { useQuery } from "react-query";
import { AvpAPI } from "@jti/rest-api";
export const useHiddenAgeVerification = () => {
    const { data: isAgeVerificationHidden, isFetching: isAgeVerificationHiddenLoading } = useQuery("isAgeVerificationHidden", () => AvpAPI.init().isAgeVerificationHidden(), {
        staleTime: Infinity,
    });
    return {
        isAgeVerificationHidden,
        isAgeVerificationHiddenLoading,
    };
};
